import Header from "../components/Header";
import AccountManager from "../components/AccountManager";
import { useEffect } from "react";

const AccountManagerPage: React.FC = () => {
  useEffect(() => {
    document.title = "F&M - Account Manager";
  }, []);
  return (
    <>
      <Header onProfileClick={() => {}} hideAccountManagerLink />
      <main className="account-manager-page-container">
        <AccountManager />
      </main>
    </>
  );
};

export default AccountManagerPage;
